import type { DadosDeducao } from "../ComponentsExtractAnalysis/DeducaoTable/DeducaoTable";
import type { PatchExtratoAnalisePayload } from "../../../../services/ExtractService";

function includeId(id: unknown): { id: number } | Record<string, never> {
  const idNum = Number(id);
  return idNum > 0 ? { id: idNum } : {};
}

export function buildPatchExtratoAnalisePayload(
  dados: DadosDeducao,
): PatchExtratoAnalisePayload {
  const atraso = dados.deducaoAtraso;
  const hasAtraso = atraso != null && Object.keys(atraso).length > 0;

  const deducaoAtraso = hasAtraso
    ? {
        deduzir: !!(atraso as { deduzir?: boolean }).deduzir,
      }
    : undefined;

  const deducaoTitulos = (dados.deducaoTitulos || [])
    .filter((t) => t?.titulo && typeof t?.valor !== "undefined")
    .map((t) => ({
      ...includeId(t.id),
      ...(Number(t.recno) > 0 ? { recno: Number(t.recno) } : {}),
      filial: String(t.filial || "").trim(),
      titulo: String(t.titulo || "").trim(),
      parcela: String(t.parcela || "").trim(),
      natureza: String(t.natureza || "").trim(),
      vencimento: t.dataVencimento || "",
      valor: Number(t.valor) || 0,
      deduzir: !!t.deduzir,
    }));

  const deducaoOutros = (dados.deducaoOutros || [])
    .filter(
      (o) => o?.descricao?.trim() !== "" && typeof o?.valor !== "undefined",
    )
    .map((o) => ({
      ...includeId(o.id),
      descricao: String(o.descricao || "").trim(),
      valor: Number(o.valor) || 0,
      deduzir: !!o.deduzir,
    }));

  return {
    ...(deducaoAtraso !== undefined ? { deducaoAtraso } : {}),
    deducaoTitulos,
    deducaoOutros,
  };
}
